import "./styles/main.css";
import "jquery";
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import jsZip from 'jszip'
import DataTable from 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.colVis.mjs';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-buttons/js/buttons.print.mjs';
import 'datatables.net-responsive-bs5';


import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faInstagram, faLinkedin, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import facetsData from "./facets.json";

// redirect if name != /upgradematrix/
if (window.location.pathname === "/upgradematrix") { window.location = window.location.href + '/'; }

pdfMake.vfs = pdfFonts.pdfMake.vfs;
window.pdfMake = pdfMake;
window.JSZip = jsZip;

library.add(faFacebook, faInstagram, faLinkedin, faTwitter, faYoutube, faCircleInfo);
dom.watch();


const newFeaturesCache = {};
const startVersionDropdown = document.getElementById('startVersionDropdown');
const endVersionDropdown = document.getElementById('endVersionDropdown');
const endVersionDefaultOption = document.getElementById('endVersionDefaultOption');

const table = new DataTable('#dataTable', {
    dom: 'Bfrtip',
    buttons: [
        'colvis',
        {
            extend: 'print',
            exportOptions: {
                columns: ':visible'
            }
        },
        {
            extend: 'copy',
            exportOptions: {
                columns: ':visible'
            }
        },
        {
            extend: 'pdfHtml5',
            orientation: 'landscape',
            pageSize: 'LEGAL',
            exportOptions: {
                columns: ':visible',
                orthogonal: "pdf",

            },
            customize: doc => {
                // find out where the links heading is
                const linksIndex = doc.content[1].table.body[0].findIndex(p => p.text == "Links");
                if (linksIndex < 0) {
                    return;
                }
                // if there is a links heading, replace with the pdfmake data
                const bodylen = doc.content[1].table.body.length;
                console.log('bodylen', bodylen);
                for (let row = 1; row < bodylen; row++) {
                    const text = doc.content[1].table.body[row][linksIndex].text;
                    try {
                        doc.content[1].table.body[row][linksIndex] = JSON.parse(text);
                    } catch (err) {
                        doc.content[1].table.body[row][linksIndex] = '';
                        console.error(`cannot parse text "${text}"`, err);
                    }
                }
                // doc.content[1].table.widths = ["*", "*", "*", "*", "*", "*"];
            }
        },
        {
            extend: 'csv',
            exportOptions: {
                columns: ':visible',
                orthogonal: 'csv'
            }
        },
        {
            extend: 'excel',
            exportOptions: {
                columns: ':visible',
                orthogonal: 'excel'
            }
        },
    ],
    columns: [
        {
            title: 'Info Type',
            data: 'infoType'
        },
        {
            title: 'Version',
            data: 'version',
            render: {
                _: 'display',
                sort: 'sort'
            }
        },
        {
            title: 'Category',
            data: 'category'
        },
        {
            title: 'Title',
            data: 'title'
        },
        {
            title: 'Description',
            data: 'description'
        },
        {
            title: 'Links',
            data: 'links',
            render: function (data, type, row, meta) {
                if (type === 'pdf') {
                    if (data && data.length > 0) {
                        const pdfData = { ul: data.map(d => ({ text: d.text, link: d.href, style: { decoration: 'underline' } })) };
                        return JSON.stringify(pdfData);
                    }
                }
                if (type === 'csv' || type === 'excel') {
                    if (data && data.length > 0) {
                        return data.map(l => l.href).join(',');
                    }
                }
                if (type === "display") {
                    if (data && data.length > 0) {
                        return `<ul>${data.map(l => `<li><a target="_blank" href="${l.href}" ${row.isDeprecated ? 'title="This link points to a deprecated version of the software documentations and might not work."' : ''}>${l.text} ${row.isDeprecated ? "&#9888;" : ''}</a></li>`).join('')}</ul>`;
                    }
                }
                return data;
            }
        },
    ],
    order: [{
        name: 'version',
        dir: 'asc'
    },
    {
        name: 'title',
        dir: 'asc'
    }]
});


async function fetchJSON(url) {
    try {
        const resp = await fetch(url);
        return await resp.json();
    } catch (error) {
        console.warn(`unable to fetch json ${url}`);
    }
}

async function resetEndVersionDropdown() {
    endVersionDropdown.innerHTML = '';
    const clone = endVersionDefaultOption.content.cloneNode(true);
    endVersionDropdown.appendChild(clone);
}


async function populateDropdown(dropdown, facets) {
    const options = await Promise.all(facets.map(async facet => {
        const option = document.createElement('option');
        option.value = facet.minor;
        option.setAttribute('data-dirname', facet.dirname);
        option.textContent = facet.title;
        return option;
    }));
    options.map(o => o ? dropdown.appendChild(o) : null);
}

async function getSelectedValues() {
    const startValue = Number(startVersionDropdown.value);
    const endValue = Number(endVersionDropdown.value);
    return { start: startValue, end: endValue };
}

async function updateTable() {
    const tableWrapper = document.getElementById('datatable-wrapper');
    const { start, end } = await getSelectedValues();
    if (!start || !end) {
        tableWrapper.hidden = true;
        return;
    }
    const filteredVersions = facetsData.versions.filter(v => v.minor >= start && v.minor <= end);
    const tableData = await Promise.all(filteredVersions.map(async v => {
        let [nfData, chgData] = await Promise.all(["newFeatures", "Changes"].map(async t => getData(v, t)));
        return { version: v, nfData: nfData, chgData: chgData }
    }));
    table.clear();
    tableData.forEach(async data => {
        if (data.nfData && data.nfData.length > 0) {
            data.nfData.forEach(async r => {
                let dVersion = `${data.version.major}.${data.version.minor}`;
                if (r.cuPack) {
                    dVersion = `${dVersion}.${r.cuPack}`;
                }
                table.row.add({
                    infoType: 'New Feature',
                    version: {
                        display: dVersion,
                        sort: data.version.minor
                    },
                    category: r.category,
                    title: r.title,
                    description: r.description || '',
                    isDeprecated: r.isDeprecated,
                    links: r.docLinks || []
                });
            });
        }
        if (data.chgData && data.chgData.length > 0) {
            data.chgData.forEach(async r => {
                let dVersion = `${data.version.major}.${data.version.minor}`;
                if (r.cuPack) {
                    dVersion = `${dVersion}.${r.cuPack}`;
                }
                table.row.add({
                    infoType: 'Change',
                    version: {
                        display: dVersion,
                        sort: data.version.minor
                    },
                    category: r.category,
                    title: r.title,
                    description: r.description || '',
                    isDeprecated: r.isDeprecated,
                    links: r.docLinks || []
                });
            });
        }

    });
    tableWrapper.hidden = false;
    table.columns.adjust().draw().responsive.recalc();
}

startVersionDropdown.addEventListener('change', async e => {
    const selections = await getSelectedValues();
    await resetEndVersionDropdown();
    const filteredSelections = facetsData.versions.filter(v => v.minor >= selections.start);
    await populateDropdown(endVersionDropdown, filteredSelections);
    if (selections.end > selections.start) {
        endVersionDropdown.value = selections.end;
    }
    endVersionDropdown.disabled = false;
    await updateTable();
});

async function getData(v, dataType) {
    const key = `${v.minor}-${dataType}`;
    if (key in newFeaturesCache) {
        return newFeaturesCache[key];
    }
    try {
        const data = await fetchJSON(`data/${v.dirname}${dataType}.json`)
        if (!data) {
            throw (new Error(`unable to fetch data for version ${key}`));
        }
        newFeaturesCache[key] = data
        return newFeaturesCache[key];
    } catch (error) {
        console.warn(error);
        return [];
    }
}

endVersionDropdown.addEventListener('change', async () => {
    const tableLoader = document.getElementById('table-loader');
    tableLoader.hidden = false;
    await updateTable();
    tableLoader.hidden = true;
});


document.addEventListener("DOMContentLoaded", async () => {
    const tableLoader = document.getElementById('table-loader');
    const dropdowns = document.getElementById('versionDropdowns');
    await resetEndVersionDropdown();
    await populateDropdown(startVersionDropdown, facetsData.versions);
    tableLoader.hidden = true;
    dropdowns.hidden = false;
});